export default "__VITE_ASSET__DKDZ4si5__"